const React = require("react");
const createReactClass = require("create-react-class");
const Bundles = require("../Bundles");
const {augmentHOCWrapper} = require("../util/HOCUtil");

// The wrapped component receives as props a function requireOrLoadBundle,
// which is a combination of Bundles.requireOpt and Bundles.load that hooks
// into the React lifecycle in the expected way.

module.exports = augmentHOCWrapper(function(Component) {
	return createReactClass({
		displayName: "BundleLoading:" + Component.displayName,

		componentWillUnmount: function() {
			this._unmounted = true;
		},

		onLoadForName: function(bundleName) {
			// We might make multiple calls to Bundle.load. This function ensures
			// that we only update once all of them finish.
			this._pendingBundleSet.delete(bundleName);
			if (!this._unmounted && !this._pendingBundleSet.size) {
				this.forceUpdate();
			}
		},

		requireOrLoadBundle: function(bundleName, moduleName) {
			const status = Bundles.getStatus(bundleName);
			if (status !== "done" && status !== "error") {
				this._pendingBundleSet = this._pendingBundleSet || new Set();
				this._pendingBundleSet.add(bundleName);
				Bundles.load(bundleName, () => this.onLoadForName(bundleName));
			}
			return Bundles.requireOpt(bundleName, moduleName);
		},

		render: function() {
			return (
				<Component
					{...this.props}
					requireOrLoadBundle={this.requireOrLoadBundle}
				/>
			);
		},
	});
});
